import { normalizeLanguage } from './language/common'

const INVALID_PHONE_MESSAGES = {
  zh: '无效手机号',
  tw: '無效手機號',
  nl: 'Ongeldig telefoonnummer',
  uk: 'Invalid phone number',
  us: 'Invalid phone number',
  fr: 'Numero de telephone invalide',
  de: 'Ungultige Telefonnummer',
  it: 'Numero di telefono non valido',
  ja: '無効な電話番号',
  ko: '유효하지 않은 전화번호',
  pt: 'Numero de telefone invalido',
  ru: 'Недействительный номер телефона',
  es: 'Numero de telefono no valido'
}

function normalizePhoneValue(value) {
  return String(value == null ? '' : value).replace(/\s+/g, '')
}

function getInvalidPhoneMessage(language) {
  const normalized = normalizeLanguage(language)
  return INVALID_PHONE_MESSAGES[normalized] || INVALID_PHONE_MESSAGES.us
}

export function getPhoneValidationMessage(areaCode, phone, language) {
  const phoneValue = normalizePhoneValue(phone)
  const invalidPhoneMessage = getInvalidPhoneMessage(language)
  if (!phoneValue) {
    return ''
  }
  if (phoneValue.length < 5) {
    return invalidPhoneMessage
  }
  if (normalizePhoneValue(areaCode) === '+86' && phoneValue.length !== 11) {
    return invalidPhoneMessage
  }
  return ''
}
